import { subscribe } from './event-logger';
import { EVENT_TYPES, TWITTER_EVENT_TYPES } from './event-types';

const twitterTracker = {
    trackPageView() {
        window.twq?.('track', 'PageView');
    },

    track(eventId) {
        window.twq?.('event', eventId);
    }
}

subscribe((eventType) => {
    if (eventType === EVENT_TYPES.PAGE_VIEW) {
        return twitterTracker.trackPageView();
    }

    if (TWITTER_EVENT_TYPES.hasOwnProperty(eventType)) {
        twitterTracker.track(TWITTER_EVENT_TYPES[eventType]);
    }
});

export {
    twitterTracker
}
